<ng-container *transloco="let t; prefix: scope">
  <table class="w-full">
    <tr>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td class="table-label" colspan="2">{{ t('businessArea') }}</td>
      <td class="table-label">{{ t('registrationDate') }}</td>
    </tr>
    <tr>
      <td class="editor-cell" colspan="2">
        <input
          type="text"
          class="form-control"
          (change)="emitBusinessDetails()"
          [(ngModel)]="clientBusinessDetails.businessArea"
          maxlength="50" />
      </td>
      <td class="editor-cell">
        <app-calendar
          [(selectedDate)]="clientBusinessDetails.registrationDate"
          [minSelectableDate]="minSelectableDate"
          [defaultDate]="null"
          (selectedDateChange)="emitBusinessDetails()"
          styleClass="w-full"></app-calendar>
      </td>
    </tr>
    <tr>
      <td colspan="3" class="table-label">{{ t('descriptionOfBusiness') }}</td>
    </tr>
    <tr>
      <td colspan="3" class="editor-cell">
        <textarea
          rows="5"
          cols="260"
          (change)="emitBusinessDetails()"
          class="w-100 form-control"
          [(ngModel)]="clientBusinessDetails.description"
          maxlength="300"></textarea>
      </td>
    </tr>
    <tr>
      <td colspan="3" class="table-label">{{ t('specialRules') }}</td>
    </tr>
    <tr>
      <td colspan="3" class="editor-cell">
        <textarea
          rows="5"
          cols="130"
          (change)="emitBusinessDetails()"
          class="w-100 form-control"
          [(ngModel)]="clientBusinessDetails.specialRules"
          maxlength="300"></textarea>
      </td>
    </tr>
    <tr>
      <td colspan="3" class="table-label">{{ t('otherImportentClientInfo') }}</td>
    </tr>
    <tr>
      <td colspan="3" class="editor-cell">
        <textarea
          rows="5"
          cols="130"
          (change)="emitBusinessDetails()"
          class="w-100 form-control"
          [(ngModel)]="clientBusinessDetails.otherInfo"
          maxlength="300"></textarea>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="table-label">{{ t('bank') }}</td>
      <td class="table-label">{{ t('accountant') }}</td>
    </tr>
    <tr>
      <td class="editor-cell" colspan="2">
        <input
          type="text"
          class="form-control"
          (change)="emitBusinessDetails()"
          [(ngModel)]="clientBusinessDetails.bank"
          maxlength="40" />
      </td>
      <td class="editor-cell">
        <input
          type="text"
          class="form-control"
          (change)="emitBusinessDetails()"
          [(ngModel)]="clientBusinessDetails.accountant"
          maxlength="40" />
      </td>
    </tr>
    <tr></tr>
  </table>
</ng-container>

<div style="height: 15px"></div>
<div class="flex justify-end items-end -m-5 -mb-7 mt-6 p-4 bg-bl-grey-100">
  <bl-frontend-button
    variant="secondary"
    class="mr-3"
    (click)="close(-1)"
    [text]="'shared.close' | transloco"></bl-frontend-button>
  <bl-frontend-button
    (click)="close(1)"
    [disabled]="clientBusinessDetails.archived || clientBusinessDetails.id === -1"
    [text]="'shared.save' | transloco">
  </bl-frontend-button>
</div>
